const themeClassName = (theme: string) => (theme ? `theme__${theme}` : '');

export default themeClassName;
